import React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment";

import * as a from "./action";
import * as t from "./thunk";
import { DataTable } from "../DataComponents";
import { round } from "../Utilities";
const componentTransformer = R.compose(
  connect(
    (state) => state.deductions,
    (dispatch) => bindActionCreators({ ...a, ...t }, dispatch)
  )
);

class DeductionsTable extends React.Component {
  async componentDidMount() {
    await this.props.fetchDeductions();
  }

  componentWillUnmount() {
    this.props.clearDeductions();
  }

  render() {
    return (
      <DataTable
        defaultSortBy="liabilityDate"
        defaultSortDirection="down"
        dataName="Deductions"
        data={this.props.items}
        columns={this.columns}
        dataTransformer={this.dataTransformer}
      />
    );
  }

  dataTransformer = ({ ...deduction }) => ({
    liabilityDate: moment(deduction.liabilityDate).format("MM/DD/YYYY"),
    cardId: deduction.cardId,
    merchant: deduction.merchant,
    liabilityAmount: round.format(deduction.liabilityAmount),
    externalCardID: deduction.externalCardID,
    liabilityStatus: deduction.liabilityStatus,
    liabilityReason: deduction.liabilityReason,
    reasonDetails: deduction.reasonDetails,
    deductionDate: moment(deduction.deductionDate).format("MM/DD/YYYY"),
  });

  // TODO: Move this to the store to make the columns movable.
  get columns() {
    return [
      { label: "Liability Date", dataKey: "liabilityDate" },
      { label: "Card ID", dataKey: "cardId", numeric: true, alignRight: true },
      { label: "Merchant", dataKey: "merchant" },
      { label: "Liability Amount", dataKey: "liabilityAmount", numeric: true },
      {
        label: "External Card ID",
        dataKey: "externalCardID",
        width: 250,
      },
      { label: "Liability Status", dataKey: "liabilityStatus" },
      { label: "Liability Reason", dataKey: "liabilityReason" },
      { label: "Reason Details", dataKey: "reasonDetails" },
      { label: "Deduction Date", dataKey: "deductionDate" },
    ];
  }
}

DeductionsTable = componentTransformer(DeductionsTable);

export { DeductionsTable };
